import { APITypesV1 } from "@cur8/api-client";

export function limsManagedSamples(
  samples: readonly APITypesV1.BloodSample[] | undefined
): APITypesV1.BloodSample[] {
  return (samples ?? []).filter(
    (sample) => sample.analyticalFlow === APITypesV1.AnalyticalFlow.LimsManaged
  );
}

export function hasLimsManagedSamples(
  samples: readonly APITypesV1.BloodSample[] | undefined
): boolean {
  return limsManagedSamples(samples).length > 0;
}

// Draw-confirmation renders plasma's tubes first, then whole blood's.
const TUBE_TYPE_ORDER: readonly APITypesV1.SampleType[] = [
  APITypesV1.SampleType.Plasma,
  APITypesV1.SampleType.WholeBlood,
];

export const sampleTypeLabels: Record<APITypesV1.SampleType, string> = {
  [APITypesV1.SampleType.Plasma]: "Plasma",
  [APITypesV1.SampleType.WholeBlood]: "Whole Blood",
};

export function orderedTubes(
  samples: readonly APITypesV1.BloodSample[] | undefined
): APITypesV1.BloodSample[] {
  const bySampleType = new Map<
    APITypesV1.SampleType,
    APITypesV1.BloodSample[]
  >();
  for (const sample of limsManagedSamples(samples)) {
    const list = bySampleType.get(sample.sampleType);
    if (list) {
      list.push(sample);
    } else {
      bySampleType.set(sample.sampleType, [sample]);
    }
  }
  return TUBE_TYPE_ORDER.flatMap((type) => bySampleType.get(type) ?? []);
}

export type TubeResolution = "pending" | "drawn" | "skipped";

// The backend doesn't echo back why a tube was skipped, so the reason is
// only known locally for this session — not recoverable on reload.
export function resolutionFor(sample: APITypesV1.BloodSample): TubeResolution {
  const status = sample.preAnalyticalStatus;
  if (status == null) {
    return "pending";
  }
  return status === APITypesV1.PreAnalyticalStatus.NotDrawn
    ? "skipped"
    : "drawn";
}
